export default "/fonts/vendor/react-notifications/lib/notification.svg?5d0158671dd860c714c4424237520eb8";